export const getNewUrlWithLanguage = (pathname: string, queryString: string, languageCode: string) => {
  const lowerCaseLang = languageCode.toLowerCase();

  // get current Language if it's exist
  const pathSegments = pathname.split("/").filter(Boolean);
  const currentLang = pathSegments[0];

  let pathWithoutLang = pathname;
  // if language exists -> get path without language
  if (currentLang) {
    pathWithoutLang = "/" + pathSegments.slice(1).join("/");
  }

  const normalizedPath = pathWithoutLang === "/" ? "" : pathWithoutLang;
  // forming new path with new LN and path
  const newPath = `/${lowerCaseLang}${normalizedPath}`;

  return `${newPath}${queryString}`;
};
